/* Florema · Product card behaviors
   - Quick-add botón "+" o "Agregar" en cards
   - AJAX a /cart/add.js
   - Si hay cart drawer (window.FloremaCart), lo abre tras agregar
*/

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (window.__floremaCardsInit) return;
    window.__floremaCardsInit = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-florema-card-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      var origHTML = btn.innerHTML;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.classList.add('is-added');
          if (btn.classList.contains('florema-card__quick-add')) {
            btn.innerHTML = '✓';
          } else {
            btn.innerHTML = '<span class="florema-card__add-bar-label">¡Agregado!</span>';
          }

          // Abrir cart drawer si existe
          if (window.FloremaCart && typeof window.FloremaCart.open === 'function') {
            window.FloremaCart.open();
          }

          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.innerHTML = origHTML;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          console.error('Florema card add error', err);
          btn.disabled = false;
        });
    });
  });
})();
